let _pending = null;

export const setPendingMatchModal = (modalProps) => { _pending = modalProps; };
export const getPendingMatchModal = () => _pending;
export const clearPendingMatchModal = () => { _pending = null; };


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/pendingMatchModal.js